module.exports = __webpack_public_path__ + "static/media/thunderstorm-sun.5ad6787c.svg";